import {
  CANCEL_INGESTION_REQUEST,
  CANCEL_INGESTION_SUCCESS,
  CANCEL_INGESTION_FAILURE,
  CANCEL_INGESTION_RESET,
} from '../../../Constants/actionTypes';

const initialState = {
  loading: false,
  data: null,
  error: null,
};

const yadsCancelIngestionReducer = (state = initialState, action) => {
  switch (action.type) {
    case CANCEL_INGESTION_REQUEST:
      return { ...state, loading: true, error: null };
    case CANCEL_INGESTION_SUCCESS:
      return { ...state, loading: false, data: action.payload, error: null };
    case CANCEL_INGESTION_FAILURE:
      return { ...state, loading: false, error: action.payload };
    case CANCEL_INGESTION_RESET:
      return initialState;
    default:
      return state;
  }
};

export default yadsCancelIngestionReducer;
